import { IModel } from "./client.type";
import { TemplateModel } from "./enum.type";

/**
 * SDK类型，当前分：主SDK、Slave SDK
 */
export enum SDKType {
  MAIN = "MAIN_SDK",
  SLAVE = "SLAVE_SDK",
}

export interface ISlaveConfig {
  // 布局模式：auto：自动布局，custom：自定义布局
  model?: IModel;
  // 入会是否自动静音
  muteAudio?: boolean;
  // 入会是否自动关闭摄像头
  muteVideo?: boolean;
  templateModel?: TemplateModel;
  logPath?: string;
  // 指定dll路径，支持相对路径和绝对路径
  // 相对路径：相对于程序或项目的根路径，例如："./dll/"，则需要在程序或项目的根路径下创建dll目录，放置所有的dlls文件
  // 绝对路径：windows系统路径，例如："C:/dll"，则会加载C盘下dll目录下的dlls文件
  dllPath?: string;
  path?: string;
  sdkDllPath?: string;
  sdkProjectPath?: string;
  container?: {
    elementId?: string; // 容器ID
    offset?: number[]; // 偏移量
  };
}
